import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';


@Component({
  selector: 'app-add-insurance',
  templateUrl: './add-insurance.component.html',
  styleUrls: ['./add-insurance.component.css']
})
export class AddInsuranceComponent implements OnInit {
  data: any ={};
  value: any;
  id: any;
  type: any;
  policyType: any;
  insurer: any;
  policyNumber: any;
  renewalDate: any;
  productName: any;
  premium: any;
  sumAssured: any;
  daysBeforeDueDate: any;
  weeksBeforeDueDate: any;
  monthsBeforeDueDate: any;
  public array:any = [];
  selectedFile: File;
  attachImage: File;
  loading: boolean;

  private onDestroy$: Subject<void> = new Subject<void>();

  onFileChanged(event) {
    this.selectedFile = event.target.files[0]
  }


  onUpload() {
    // upload code goes here
  }
 

  constructor(private router: Router, private serviceURLService: serviceURLService) { }

  ngOnInit() {

     
  }

 
  
  addInsuranceDetails(){
    this.loading = true;
    this.renewalDate = new Date(this.data.dueDate).getTime();
    this.data.fields = [
       { value: this.data.policyType, id: 'policyType', type: 'TEXT', visibility: true },
       { value: this.data.insurer, id: 'insurer', type: 'TEXT', visibility: true },
       { value: this.data.policyNumber, id: 'policyNumber', type: 'NUMBER', visibility: true },
       { value: this.renewalDate, id: 'renewalDate', type: 'DATE', visibility: true },
       { value: this.data.productName, id: 'productName', type: 'TEXT', visibility: true },
       { value: this.data.premium, id: 'premium', type: 'TEXT', visibility: true },
       { value: this.data.sumAssured, id: 'sumAssured', type: 'NUMBER', visibility: true } 
    ]

    this.data.reminders = [];
     this.data.reminders.push({ 
      'daysBeforeDueDate': this.data.daysBeforeDueDate,
      'weeksBeforeDueDate': this.data.weeksBeforeDueDate,
      'monthsBeforeDueDate': this.data.monthsBeforeDueDate,
    });
    

    this.data = {
      "fields": (this.data.fields),
      "attachments":[],
      "isDeleted": 'false',
      "linkedToCard": 'false',
      "dynamic_fields": [],
      "reminders": (this.data.reminders),
      "isSynced": 'false' 
    }


    //console.log(this.data);
    //return false;
    //let selectedDates = [];
    

    this.serviceURLService.addInsurance(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      console.log("Policy added successfully",successData.message)
      this.loading = false;
      this.successfullyAddedMessage = successData.message;
    }, errorData => {
      if(errorData.error.status === 401){
        localStorage.clear();
        alert("Login session has been expired..!! Please Login again.")
        this.router.navigate(['login']);
      }
      console.log("Error");
    })
  }
  successfullyAddedMessage(message: any): any {
    throw new Error("Method not implemented.");
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}
